import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import './PromptMobile.css';
import './darkTheme.css';

const PromptMobile = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // State to track loading user attributes
  const [isMobile, setIsMobile] = useState(false);  // whether the user is accessing the page from mobile

  function isClientMobile() {
      // Determine the route based on window.innerWidth
      return window.innerWidth <= 768;
  }

  useEffect(() => {
    // Fetch the authenticated user's attributes
    const fetchUserAttributes = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const attributes = await Auth.userAttributes(user);
        const mobileAttribute = attributes.find(attr => attr.Name === 'custom:mobile');

        if (mobileAttribute) {
          // If 'custom:mobile' attribute exists, set it in the state
          setPhoneNumber(mobileAttribute.Value);
        }

        setLoading(false);
        setIsMobile(isClientMobile());
        
      } catch (error) {
        console.error('Error fetching user attributes:', error);
      }
    };

    fetchUserAttributes();
  }, []);

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Authenticate the user with AWS Cognito (you should set up Amplify configurations)
      const user = await Auth.currentAuthenticatedUser();

      // Update the custom attribute 'custom:mobile'
      await Auth.updateUserAttributes(user, {
        'custom:mobile': phoneNumber,
      });

      // Determine the route based on window.innerWidth
      const route = window.innerWidth <= 768 ? '/dashboardMobile' : '/dashboard';

      // Navigate to the next screen (you should define your route accordingly)
      navigate(route);
    } catch (error) {
      console.error('Error updating user attributes:', error);
    }
  };

  return (
    <div className="mobile-prompt-div">
      <h2>Before we begin, what is your mobile number?</h2>
      {isMobile ? (
        <p>(Enter your mobile number to request a WhatsApp verification code to connect to our service)</p>
      ) : (
        <p>(We ask because we need to identify your WhatsApp ID for display purpose)</p>
      )}
      {loading ? (
        <p>Loading...</p>
      ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="tel"
              placeholder="Mobile Phone Number"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              required
            />
            <button className="center-submit-button" type="submit">Submit</button>
          </form>
      )}
    </div>
  );
};

export default PromptMobile;